import { render } from "./DuplicateShiftDialog.vue?vue&type=template&id=fc1bb624&ts=true"
import script from "./DuplicateShiftDialog.ts?vue&type=script&lang=ts"
export * from "./DuplicateShiftDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__